import { useMutation } from '@tanstack/react-query'
import { ExtendableMutationOptions } from 'shared/api/api.types'
import { authApi } from 'shared/api/auth'

import {
  OauthRedirectRequest,
  OauthRedirectResponse
} from './oauthRedirect.types'

export const oauthRedirect = async (request: OauthRedirectRequest) => {
  const response = await authApi.get<OauthRedirectResponse>('oauth/redirect', {
    params: request
  })
  return response.data
}

export const useOauthRedirectMutation = (
  options?: ExtendableMutationOptions<
    OauthRedirectResponse,
    OauthRedirectRequest
  >
) => {
  return useMutation({
    mutationFn: oauthRedirect,
    ...options
  })
}
